import axios from 'axios';
export default class MenuService {
    async GetUserMenuList(data) {
        return await axios .post('api/v1/admin/user/menu', data);
    }
}
